/**
 *
 * Search Service Reducer
 *
 */
import { NOT_ASKED, LOADING, SUCCESS, FAILURE, UPDATE_ALREADY_REQUESTED_TRANSFER } from './constants';

function reducer(state = {}, action) {
  const {
    type,
    results,
    params,
    transferId,
    newData,
  } = action;

  switch (type) {
    case NOT_ASKED:
      return { status: NOT_ASKED };
    case LOADING:
      return { status: LOADING, params };
    case SUCCESS:
      return {
        ...state, status: SUCCESS, results: results.rows, nextPageToken: results.nextPageToken, previousPageToken: results.previousPageToken, totalSize: results.totalSize,
      };
    case FAILURE:
      return { ...state, status: FAILURE, error: action.error };
    case UPDATE_ALREADY_REQUESTED_TRANSFER:
      return { ...state, results: updateTransfer(transferId, newData, state.results) };
    default:
      return state;
  }
}

export function updateTransfer(transferId, newData, allTransfers) {
  // Find the transfer that we want to update
  const transferToUpdate = allTransfers.find((transfer) => transfer.id === transferId);
  // update the relevant portions
  const updatedTransfer = {
    ...transferToUpdate,
    prescribedActions: newData.prescribedActions,
    auditEvents: newData.auditEvents,
    state: newData.state,
    amount: newData.amount,
  };
  // return all the transfers, but with one of them updated.
  return [
    ...allTransfers.filter((transfer) => transfer.id !== transferId),
    updatedTransfer,
  ];
}

export default reducer;



// WEBPACK FOOTER //
// ./src/services/search/reducer.js